
export const GetDateToday = () =>{
    let d = new Date();
    let date = d.getDate();
    let month = d.getMonth() + 1; // Since getMonth() returns month from 0-11 not 1-12.
    let year = d.getFullYear();
    return year + "-" + ("0" + month).slice(-2) + "-" + date;
}

export const getTwoDateCompare = (ComparedDate) =>{
let DateToday = new Date(GetDateToday());
if(new Date(ComparedDate)>=DateToday){
    return true;
}
return false
}